export const SET_USER_ROLES_LOADED = "SET_USER_ROLES_LOADED";

export const setUserRolesLoaded = (userRolesLoaded: boolean) => {
  return {
    userRolesLoaded,
    // tslint:disable-next-line:object-literal-sort-keys
    type: SET_USER_ROLES_LOADED
  };
};
